//@ts-nocheck
import { useContext, useState } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Avatar,
  Tooltip,
  IconButton,
  useMediaQuery,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import vietnamFlag from "../../../assets/Images/flags/vietnamFlag.png";
import englandFlag from "../../../assets/Images/flags/englandFlag.png";
import logo from "../../../assets/Images/Logo.png";
import logoDarkMode from "../../../assets/Images/Logo-darkmode.png";
import { AppsOutlined } from "@mui/icons-material";
import LanguageContext from "languageContext";
import UserContext from "userContext";
import { stringAvatar } from "../../../Common/common";
import ColorModeContext from "ColorModeContext";
import LogoutIcon from "@mui/icons-material/Logout";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LogoutDialog from "Components/FormComponents/Dialog";
import { clearLocalStorage } from "../../../Common/common";
import PopoverComponent from "Components/popover";

export default function Header({
  onBackToLandingPage,
}: {
  onBackToLandingPage: () => void;
}) {
  const isTabletOrMobile = useMediaQuery("(max-width: 1050px)");
  const { user, setUser } = useContext(UserContext);
  const { language, setLanguage } = useContext(LanguageContext);
  const { mode, setMode } = useContext(ColorModeContext);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorEl);
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const jsondata = window._env_;
  const navigate = useNavigate();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChaneModeView = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
    localStorage.setItem("mode", mode === "light" ? "dark" : "light");
  };

  const handleChangeLanguage = (language: string) => {
    setLanguage({ language });
    i18n.changeLanguage(language);
  };

  const handleLogout = () => {
    const { beAdminUrl } = jsondata;
    const logout = async () => {
      await fetch(`${beAdminUrl}/logout`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        if (res.status === 200) {
          Cookies.remove("token");
          localStorage.removeItem("mode");
          setMode("light");
          setUser(null);
          clearLocalStorage();
          navigate("/login");

          return;
        }
      });
    };
    logout();
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isTabletOrMobile ? "space-between" : "flex-end",
        alignItems: "center",
      }}
    >
      {isTabletOrMobile &&
        (theme.palette.mode === "light" ? (
          <img
            src={logo}
            alt="logo"
            width={80}
            height={20}
            style={{ cursor: "pointer" }}
            onClick={onBackToLandingPage}
          />
        ) : (
          <img
            src={logoDarkMode}
            alt="logo"
            width={80}
            height={25}
            style={{ cursor: "pointer" }}
            onClick={onBackToLandingPage}
          />
        ))}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          paddingY: "20px",
        }}
      >
        <IconButton onClick={handleChaneModeView}>
          {mode === "dark" ? (
            <LightModeOutlinedIcon />
          ) : (
            <DarkModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton sx={{ mr: 1 }} onClick={handleClick}>
          <AppsOutlined />
        </IconButton>
        <PopoverComponent
          isOpen={isOpen}
          anchorEl={anchorEl}
          handleClose={handleClose}
        />

        <FormControl>
          <Select
            defaultValue={language?.language || "vi"}
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": {
                border: 0,
              },
              ".MuiSelect-icon": { display: "none" },
              paddingRight: 0,
            }}
            variant="standard"
            disableUnderline
            onChange={(e) => handleChangeLanguage(e.target.value as string)}
          >
            <MenuItem value="vi">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={vietnamFlag}
                  alt="Vietnamese flag"
                  width={25.6}
                  height={17.9}
                />
                <Typography
                  sx={{
                    color: theme.palette.mode === "dark" ? "#ffff" : "black",
                    fontFamily: "San Francisco Text",
                    fontSize: "14px",
                    ml: 1,
                  }}
                >
                  VI
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="en">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={englandFlag}
                  alt="England flag"
                  width={25.6}
                  height={17.9}
                />
                <Typography
                  sx={{
                    color: "black",
                    fontFamily: "San Francisco Text",
                    fontSize: "14px",
                    ml: 1,
                  }}
                >
                  EN
                </Typography>
              </Box>
            </MenuItem>
          </Select>
        </FormControl>
        <Avatar {...stringAvatar(`${user?.firstName} ${user?.lastName}`)} />
        {!isTabletOrMobile && (
          <Typography
            sx={{
              color: theme.palette.mode === "dark" ? "#ffff" : "black",
              fontFamily: "San Francisco Text",
              fontSize: "14px",
            }}
          >
            {user?.firstName + " " + user?.lastName}
          </Typography>
        )}
        <Divider
          orientation="vertical"
          flexItem
          sx={{ color: "#9CA3AF", mx: 1 }}
        />
        <Tooltip title={t("auth.logout.title")} placement="bottom">
          <IconButton
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              "&:hover": {
                backgroundColor: "transparent",
                opacity: 1,
              },
            }}
            onClick={() => setOpen(true)}
          >
            <LogoutIcon
              sx={{
                color: theme.palette.mode === "dark" ? "#ffff" : "#21252C",
              }}
            />
          </IconButton>
        </Tooltip>
        {!isTabletOrMobile && (
          <Typography
            variant="h6"
            sx={{ color: theme.palette.mode === "dark" ? "#ffff" : "black" }}
          >
            Đăng xuất
          </Typography>
        )}
      </Box>
      <LogoutDialog
        open={open}
        handleClose={() => setOpen(false)}
        handleLogout={handleLogout}
      />
    </Box>
  );
}
